'use client';

import { memo, useEffect } from 'react';

import useWckDisplayInterface from '@hooks/useWckDisplayInterface';

function PromotionBridgeWebInterface() {
  const wckEventInterface = useWckDisplayInterface();
  useEffect(() => {
    window.wckDisplayInterface = wckEventInterface;
    window?.wckPageInit?.();
  }, []);
  return null;
}

export default memo(PromotionBridgeWebInterface);
